import React, {useState} from 'react'
import { useNavigate } from 'react-router'
import { addIcon } from '@/assets/img/imgAssets'
import { PlusIcon, MinusIcon, TrashIcon, PencilSquareIcon } from '@heroicons/react/24/outline'
import PulseLoader from "react-spinners/PulseLoader"
import { useGetCapabilitiesSoftSkillFunctionAreaTypesQuery } from './capabilitiesSoftSkillFunctionAreaTypesApiSlice'

const EtCapabilitiesSoftSkillFunctionAreaTypeList = ({ setActiveAdminView, onAdd, onUpdate, onDelete, setSelectedEntityId }) => {

  // First Created - 18 Nov 2024
  // Author - Atul Pandey
  // Inherited from functionType
  // Updated - 27 Feb 2025 - updated the softSkillFunctionArea with props - { setActiveAdminView, onAdd, onUpdate, onDelete, setSelectedEntityId }
  // Updated - 27 Feb 2025 - switched from navigate to onAdd, onUpdate, onDelete, setSelectedEntityId
    
  // 1 - Set navigation
  const navigate = useNavigate()
  
  // 2a - Initialize showDetails state as an object where key is the capabilitiesSoftSkillFunctionAreaType index
  const [showDetails, setShowDetails] = useState({}); // Toggle softSkill type sections
  const [showSoftSkillTypeSection, setShowSoftSkillTypeSection] = useState({}); // Toggle softSkill type sections

  const { data: capabilitiesSoftSkillFunctionAreaTypesData, isError, error, isLoading } =
  useGetCapabilitiesSoftSkillFunctionAreaTypesQuery();


// 2b - Group softSkill function areas by softSkill type
const groupedSoftSkillFunctionAreas = capabilitiesSoftSkillFunctionAreaTypesData?.ids?.reduce((acc, id) => {
  const capability = capabilitiesSoftSkillFunctionAreaTypesData.entities[id];
  const softSkillType = capability.capabilitiesSoftSkillType?.capabilitiesSoftSkillTypeName;
  const softSkillTypePic = capability.capabilitiesSoftSkillType?.pic;

  if (!acc[softSkillType]) {
    acc[softSkillType] = { softSkillTypePic, softSkillFunctionAreas: [] };
  }
  acc[softSkillType].softSkillFunctionAreas.push(capability);
  return acc;
}, {});


  
  // 3a - Toggle the show/hide state for the specific capabilitiesSoftSkillFunctionAreaType index
  const handleToggle = (index) => {
        setShowDetails(prev => prev === index ? null : index);
  }

  // 3b - Toggle Show softSkillFunctionArea for show creation notes -- 07 Oct 2024
//   const handleToggleDomainTypeNameSection = (sectionId) => {
//     setShowDomainTypeNameSection((prev) => ({
//       ...prev,
//       [sectionId]: !prev[sectionId],
//     }))
// }
    
  // 4 - Create an object for setting inner HTML
    const createMarkup = (htmlContent) => {
    return { __html: htmlContent }
     }
  

  // 5 -  Optional: handle loading and error states
    if (isLoading) return <PulseLoader color={"#ea580c"} />
    if (isError) return <div>Error occurred: {error?.data?.message}</div>


  return (
    <div className='bg-gray-200 m-1 p-1 rounded mx-auto'>
        {/* Header */}
        <div className='flex justify-start items-center m-1 p-1'>

            <div><p className='font-poppins text-2xl m-1 p-1 font-bold'>Et Capabilities SoftSkillFunctionArea Types</p></div>
            <div>
          <img
            src={addIcon}
            alt=""
            className="h-10 w-10 cursor-pointer"
             // onClick={() => navigate("/capabilitiesSoftSkillFunctionAreatypes/create")}
             onClick={onAdd} // 27 Feb 2025
          />
        </div>

        </div>

        {/* CapabilitiesSoftSkillFunctionAreaType Data */}
        <div id='capabilitiesSoftSkillFunctionAreaType-data' className='bg-white rounded m-1 p-1 font-poppins'>
            {capabilitiesSoftSkillFunctionAreaTypesData?.ids.length === 0 && (
                <div><p>No capabilities SoftSkillFunctionArea type data exists. Click above to create one</p></div>
            )}

            <div className='bg-gray-50 rounded'>
              {Object.entries(groupedSoftSkillFunctionAreas)?.map(([softSkillTypeName, { softSkillTypePic, softSkillFunctionAreas }], index) => (
                <div key={softSkillTypeName + index} className='bg-gray-100 rounded m-1 p-1 border'>
                  {/* SoftSkill Type Header */}
                  <div className='flex justify-start items-center m-1 p-1'>
                    <div onClick={() => setShowSoftSkillTypeSection((prev) => ({
                      ...prev,
                      [softSkillTypeName]: !prev[softSkillTypeName],
                    }))}
                      className="mx-2 cursor-pointer flex justify-center items-center rounded-full h-5 w-5 hover:shadow-md hover:z-30 hover:bg-white">
                      {showSoftSkillTypeSection[softSkillTypeName] ? <MinusIcon className="h-3 w-3 text-orange-600 " /> : <PlusIcon className="h-3 w-3 text-orange-600 " />}
                    </div>
                    <div>
                      <p className='text-sm font-bold mx-1 px-1'>{index + 1} - </p>
                    </div>
                    {softSkillTypePic && (
                      <div className='flex justify-center items-center h-7 w-7 bg-gray-100 hover:bg-white rounded-full cursor-pointer mr-2'>
                        <img src={softSkillTypePic} alt="" className='h-5 w-5' />
                      </div>
                    )}
                    <p className='text-sm font-bold mx-2'>{softSkillTypeName}</p>
                  </div>

                  {/* Render SoftSkill Function Areas */}
                  {showSoftSkillTypeSection[softSkillTypeName] && (
                    <div>
                      {softSkillFunctionAreas.map((softSkillFunction, idx) => (
                        <div key={softSkillFunction._id} className='bg-gray-200 rounded m-1 p-1 border'>
                          <div className='flex justify-between items-center m-1 p-1'>
                            <div className='flex justify-start items-center mx-2'>
                              <div onClick={() => setShowDetails((prev) => ({ ...prev, [softSkillFunction._id]: !prev[softSkillFunction._id] }))}>
                                {showDetails[softSkillFunction._id] ? (
                                  <MinusIcon className="h-3 w-3 text-orange-600 " />
                                ) : (
                                  <PlusIcon className="h-3 w-3 text-orange-600 " />
                                )}
                              </div>

                              <p className='text-xs font-bold mx-1 px-1'>{idx + 1} - {softSkillFunction.capabilitiesSoftSkillFunctionAreaTypeName}</p>
                            </div>
                            <div className='flex justify-start items-center'>
                              <div 
                              
                              // onClick={() => navigate(`/capabilitiesSoftSkillFunctionAreaTypes/update/${softSkillFunction._id}`)} 
                              onClick={() => onUpdate(softSkillFunction._id)} // 27 Feb 2025
                              
                              
                              className='cursor-pointer flex justify-center items-center rounded-full h-5 w-5 hover:shadow-md hover:z-30 hover:bg-white'>
                                <PencilSquareIcon className="h-3 w-3 text-orange-600 " />
                              </div>
                              <div 
                              
                              // onClick={() => navigate(`/capabilitiesSoftSkillFunctionAreaTypes/delete/${softSkillFunction._id}`)} 
                              onClick={() => onDelete(softSkillFunction._id)} // 27 Feb 2025
                              
                              className='cursor-pointer flex justify-center items-center rounded-full h-5 w-5 hover:shadow-md hover:z-30 hover:bg-white'>
                                <TrashIcon className="h-3 w-3 text-orange-600 " />
                              </div>
                            </div>
                          </div>

                          {/* SoftSkill Function Details */}
                          {showDetails[softSkillFunction._id] && (
                            <div className='bg-white rounded text-xs py-1'>
                              <p className='font-bold m-1 p-1 border-b-2 border-orange-600'>Description:</p>
                              <div dangerouslySetInnerHTML={createMarkup(softSkillFunction.capabilitiesSoftSkillFunctionAreaTypeDesc)} className='m-1 p-1'></div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>


        </div>

    </div>
  )
}

export default EtCapabilitiesSoftSkillFunctionAreaTypeList